<template>
  <div>
    <QuickAdd v-if="$page.props.auth.user.role == 'mtd'" :isWholesale="isWholesale" :update="update"/>

    <card id="checkoutTable" icon="fas fa-shopping-cart" :title="`${shippedItems.length} ${shippedItems.length > 1 ? 'items' : 'item'} ready to be shipped`" bodyClasses="p-0">
      <div class="px-3 pt-2">
        <template v-for="(item, itemIndex) in shippedItems" :key="item.product.id">

          <ProductRow :item="item" :sku="item.product.sku"  :margin="`${itemIndex+1 === items.length ? 'mb-0' : 'mb-3'}`">
            <template v-slot:headerContent>
              <div class="col-4">
                <p class="pt-1 badge badge-success ml-2 mt-2 float-right" v-if="item.from_inventory">Item is on Truck</p>
                <p class="pt-1 badge badge-primary ml-2 mt-2 float-right" v-else>Item Will Ship</p>
                <div v-if="!isWholesale && $page.props.auth.user.role == 'mtd' && !item.product.user_id">
                  <div @click="changeToInventory(item)" class="badge badge-secondary pt-1 ml-2 mt-2 mb-2 float-right cursor-pointer" v-if="!item.from_inventory"><i class="fas fa-truck mr-1 fa-sm"></i>Change to From Truck</div>
                  <div @click="changeToShipping(item)" class="badge badge-secondary pt-1 ml-2 mt-2 float-right cursor-pointer" v-else><i class="fas fa-box mr-1 fa-sm"></i>Change to Shipping</div>
                </div>
              </div>
            </template>

            <CartItemPrice :item="item"
              :itemIndex="itemIndex"
              :isWholesale="isWholesale"
              :isCheckout="true"
              @onUpdate="update"/>
            
          </ProductRow>
        </template>
      </div>
    </card>

    <card id="checkoutTable2" :title="`${backorderItems.length} ${backorderItems.length > 1 ? 'items' : 'item'} will be placed on Backorder`" bodyClasses="p-0" class="mt-3">
      <div class="px-3 pt-2">

        <template v-for="(item, itemIndex) in backorderItems" :key="item.product.id">

          <ProductRow :item="item" :sku="item.product.sku"  :margin="`${itemIndex+1 === items.length ? 'mb-0' : 'mb-3'}`">
            <template v-slot:headerContent>
              <div class="col-4">
                <p class="badge badge-primary pt-1 ml-2 float-right">
                  <i class="fas fa-clock mr-1"></i>
                  Expected to Ship: {{ getBackorderEta(item) }}
                </p>
                <div v-if="!isWholesale && $page.props.auth.user.role == 'mtd' && !item.product.user_id">
                  <div @click="changeToInventory(item)" class="badge badge-secondary pt-1 ml-2 mt-2 mb-2 float-right cursor-pointer" v-if="!item.from_inventory"><i class="fas fa-truck mr-1 fa-sm"></i>Change to From Truck</div>
                  <div @click="changeToShipping(item)" class="badge badge-secondary pt-1 ml-2 mt-2 float-right cursor-pointer" v-else><i class="fas fa-box mr-1 fa-sm"></i>Change to Shipping</div>
                </div>
              </div>
            </template>

            <CartItemPrice :item="item"
              :itemIndex="itemIndex"
              :isWholesale="isWholesale"
              :isCheckout="true"
              @onUpdate="update"/>

          </ProductRow>
        </template>
      </div>
    </card>
  </div>
</template> 

<script>
  import ProductRow from '@/Components/Shop/ProductRow'
  import QuickAdd from '@/Components/Shop/QuickAdd'
  import CartItemPrice from '@/Components/Shop/CartItemPrice'

  export default {
    data() {
      return {
        mtd_disable_tax: false,
        formObject: this.$inertia.form({
          item_id: null,
          qty: null
        }),
        formDeleteItem: this.$inertia.form({
          item_id: null
        }),
        formUpdateDisableTax: this.$inertia.form({
          mtd_disable_tax: this.mtd_disable_tax
        }),
        formUpdateProduct: this.$inertia.form({
          item_id: null
        }),
      }
    },
    components: {
      ProductRow,
      QuickAdd,
      CartItemPrice,
    },
    props: {
      items: Array,
      lineItems: Array,
      isWholesale: {
        type: Boolean,
        default: false
      },
      for_user: {
        type: Object,
        default: null
      },
      updateItemRoute: String,
      deleteItemRoute: String,
      toggleTaxDisabledRoute: String,
      setItemDiscountRoute: String,
      clearItemDiscountRoute: String,
    },
    computed: {
      shippedItems() {
        return this.items.filter(item => !item.show_as_backorder)
      },
      backorderItems() {
        return this.items.filter(item => item.show_as_backorder)
      },
    },
    methods: {
      getBackorderEta(item) {
        if (item.backorder_eta % 7 === 0)
          return item.backorder_eta/7 + ' weeks'
        else
          return item.backorder_eta + ' days'
      },
      update() {
        this.$emit('onUpdate')
      },
      changeToInventory(item) {
        if (item.from_inventory || this.formUpdateProduct.processing) return;

        this.formUpdateProduct.item_id = item.id;
        this.formUpdateProduct.post(this.route('mtd.cart.changeToInventory'), { 
          preserveScroll: true,
          onSuccess: () => this.update()
        })
      },
      changeToShipping(item) {
        if (!item.from_inventory || this.formUpdateProduct.processing) return;

        this.formUpdateProduct.item_id = item.id;
        this.formUpdateProduct.post(this.route('mtd.cart.changeToShipping'), { 
          preserveScroll: true,
          onSuccess: () => this.update()
        })
      },
    }
  }
</script>